// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as CountryConfig from "../../../country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as CrmControlledReleaseRepoConfig from "./CrmControlledReleaseRepoConfig.bs.js";

function getAdminBetaAcessData(country) {
  var url = Config.Env.getHostName(undefined) + "/api/v1/crm/page_config_for_agent";
  return NetworkV2$Catalyst.get(url, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CrmControlledReleaseRepoConfig.BetaUserResponseConverter.execute, result);
                        });
            });
}

var BetaUserRepo = {
  getAdminBetaAcessData: getAdminBetaAcessData
};

export {
  BetaUserRepo ,
  
}
/* Config Not a pure module */
